export const getQuery = state => state.routing.locationBeforeTransitions.query;

export const getCurrentLocation = state => state.routing.locationBeforeTransitions;
